module.exports = __webpack_public_path__ + "assets/horizontal-card.3372c979.svg";